module.exports = "<qms-navigation-menu-element title=\"Queues\" translation=\"global.menu.management.queues\" [link]=\"['queues']\"> <qms-faculty-navigation-menu-element *ngFor=\"let faculty of faculties\" [faculty]=\"faculty\" [onlyCategoryQueues]=\"onlyCategoryQueues\"> </qms-faculty-navigation-menu-element> </qms-navigation-menu-element> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/management/management-navigation-menu/queues-management-navigation-menu/queues-management-navigation-menu.component.html
// module id = 266
// module chunks = 0